import {RuleResultType} from "api/quote";

/**
 * Converts technical error types to user-friendly messages
 * @param errorSummary - The raw error summary string (e.g., "required, validation, immediate_declination")
 * @returns User-friendly error message
 */
export function getUserFriendlyErrorSummary(errorSummary?: string): string {
  if (!errorSummary) {
    return "";
  }

  const errorTypes = errorSummary.split(", ").map((type) => type.trim());
  const friendlyMessages: string[] = [];

  for (const errorType of errorTypes) {
    switch (errorType) {
      case RuleResultType.REQUIRED:
        friendlyMessages.push("Missing required information");
        break;
      case RuleResultType.VALIDATION:
        friendlyMessages.push("Validation errors");
        break;
      case RuleResultType.IMMEDIATE_DECLINATION:
        friendlyMessages.push("Immediate declination");
        break;
      case RuleResultType.DECLINATION:
        friendlyMessages.push("Declination");
        break;
      case RuleResultType.REFERRED:
        friendlyMessages.push("Referral required");
        break;
      case RuleResultType.REFERRED_PRERATE:
        friendlyMessages.push("Pre-rate referral");
        break;
      case RuleResultType.WARNING:
        friendlyMessages.push("Warnings");
        break;
      default:
        friendlyMessages.push(errorType);
    }
  }

  return friendlyMessages.join(", ");
}
